'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentOperation = exports.getCurrentOperation = function getCurrentOperation(state) {
  return state.getIn(['undoRedo', 'operation']);
};
var getMostRecentTransactionId = exports.getMostRecentTransactionId = function getMostRecentTransactionId(state) {
  return state.getIn(['undoRedo', 'mostRecentTransactionId']);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoSelector.js
// module id = 474
// module chunks = 0